import type {
  AnalyticsService,
  AnalyticsServiceEvent,
  AnalyticsServicePage,
} from '../application';

export class CompositeAnalyticsService implements AnalyticsService {
  private analyticsServices: Array<AnalyticsService>;

  constructor(analyticsServices: Array<AnalyticsService>) {
    this.analyticsServices = analyticsServices;
  }

  logEvent = (event: AnalyticsServiceEvent) => {
    this.analyticsServices.forEach(service => {
      service.logEvent(event);
    });
  };

  logPage = (page: AnalyticsServicePage) => {
    this.analyticsServices.forEach(service => {
      service.logPage(page);
    });
  };
}
